import game from './GameInstance';

export default class RoomPositioner
{

  constructor(game) {

    this.game = game;

  }

  position() {

    let positionedRooms = [];
    let corridorSpacing = 100;

    this.game.rooms.forEach((room, index) => {

      if (index === 0) {

        room.x = 200;
        room.y = -600;

        positionedRooms.push(room);

        return;

      }

      let options = [];

      positionedRooms.forEach(positionedRoom => {

        // right
        options.push({
          name: 'right',
          x: positionedRoom.x + positionedRoom.width + corridorSpacing,
          y: positionedRoom.y,
          width: room.width,
          height: room.height
        });

        // left
        options.push({
          name: 'left',
          x: positionedRoom.x - room.width - corridorSpacing,
          y: positionedRoom.y,
          width: room.width,
          height: room.height
        });

        // bottom
        options.push({
          name: 'bottom',
          x: positionedRoom.x,
          y: positionedRoom.y + positionedRoom.height + corridorSpacing,
          width: room.width,
          height: room.height
        });

        // top
        options.push({
          name: 'bottom',
          x: positionedRoom.x,
          y: positionedRoom.y - room.height - corridorSpacing,
          width: room.width,
          height: room.height
        });

      });

      options = this.filterOccupiedLocations(positionedRooms, options, corridorSpacing);
      let bestOption = this.findBestOption(room, options, positionedRooms[0]);

      room.x = bestOption.x;
      room.y = bestOption.y;

      positionedRooms.push(room);

    });

    this.moveRoomsToOrigin();

  }

  findBestOption(room, options, firstRoom)
  {

    let frX = firstRoom.x + firstRoom.width / 2;
    let frY = firstRoom.y + firstRoom.height / 2;

    options.forEach(option => {

      let x = option.x + room.width / 2;
      let y = option.y + room.height / 2;

      option.distance = Math.sqrt(Math.pow(frX - x, 2) + Math.pow(frY - y, 2));

    });

    options.sort((a, b) => {

      if (a.distance === b.distance) { return 0; }
      if (a.distance > b.distance) { return 1; }
      return -1;

    });

    return options[0];

  }

  filterOccupiedLocations(positionedRooms, options, spacing)
  {
    let i = options.length;

    while (i--) {
      let option = options[i];
      let j = positionedRooms.length;

      let collides = false;

      while (j--) {

        let positionedRoom = positionedRooms[j];

        if (option.x > positionedRoom.x + positionedRoom.width + spacing - 1 || option.x + option.width + spacing - 1 < positionedRoom.x || option.y > positionedRoom.y + positionedRoom.height + spacing - 1 || option.y + option.height + spacing - 1 < positionedRoom.y) {
          continue;
        }

        collides = true;
        break;

      }

      if (collides) {
        options.splice(i, 1);
      }

    }

    return options;
  }


  moveRoomsToOrigin()
  {


    let minX = null;
    let minY = null;
    let maxX = null;
    let maxY = null;

    this.game.rooms.forEach(room => {

      if (minX === null || room.x < minX) { minX = room.x; }
      if (maxX === null || room.x + room.width > maxX) { maxX = room.x + room.width; }

      if (minY === null || room.y < minY) { minY = room.y; }
      if (maxY === null || room.y + room.height > maxY) { maxY = room.y + room.height; }

    });

    minX -= 200;
    minY -= 270;

    maxX -= minX;
    maxY -= minY;

    this.game.width = maxX + 200;
    this.game.height = maxY + 200;

    let diff = Math.abs(this.game.width - this.game.height);

    if (this.game.width > this.game.height) {
      this.game.height = this.game.width;
      minY -= diff / 2;
    }
    else{
      this.game.width = this.game.height;

      minX -= diff / 2;
    }


    this.game.rooms.forEach(room => {

      room.x -= minX;
      room.y -= minY;

    });


      let x = this.game.scale * (this.game.width - 200);
      let y = this.game.scale * (this.game.height - 200);

      let windowX = this.game.scale * game.getWindowSize().width;
      let windowY = this.game.scale * game.getWindowSize().height;

      this.game.x = -((windowX/2) - (x/2))
      this.game.y = -((windowY/2) - (y/2))

      this.game.moveViewport(0, 0);

  }

}
